// Third party --------------

import PropTypes from 'prop-types'
import { styled } from 'styled-components'

// Rest ---------------------
import capitalize from 'core/helpers/capitalizeFirstLetter'
import { formatPhone } from 'core/helpers/phoneNumberFormatter'
import { onSurfaceMuted } from 'core/styles'

const Label = styled.div`
  color: ${(p) => (p.isPlaceholder ? onSurfaceMuted : 'inherit')};
  font-weight: normal;
`
const Sublabel = styled.div`
  text-transform: capitalize;
  color: ${onSurfaceMuted};
  font-size: 14px;
  font-weight: 300;
`
const Option = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const ContactsOptionLabel = (props) => {
  const {
    affiliation,
    displayLabel: displayLabelFromContact,
    isPlaceholder,
    isUserInputtedPhoneNumber,
    label,
    name,
    sublabel,
    value,
  } = props

  const formattedValue =
    value ?
      value.includes('+1') ?
        value
      : `+1${value}`
    : null
  const phone = formatPhone(formattedValue)

  const isSelf = affiliation === 'self'

  const newDisplayLabel =
    isUserInputtedPhoneNumber ? phone || 'Enter number or select contact'
    : isSelf ? `${capitalize(label)} ${phone}`
    : `${name ? `${name} ` : ''}${phone}`

  return (
    <Option>
      <Label isPlaceholder={isPlaceholder}>{displayLabelFromContact || newDisplayLabel}</Label>
      {sublabel && <Sublabel>{sublabel}</Sublabel>}
    </Option>
  )
}

ContactsOptionLabel.propTypes = {
  affiliation: PropTypes.string,
  displayLabel: PropTypes.string,
  group: PropTypes.string,
  isPlaceholder: PropTypes.bool,
  isUserInputtedPhoneNumber: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  sublabel: PropTypes.string,
  value: PropTypes.string,
}

export default ContactsOptionLabel
